import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { register } from "../_redux/authCrud";
import { Modal } from "react-bootstrap";
import {
  validationEmail,
  validationPassword,
  validationPhoneNumber,
  validationName,
} from "../../../utils/validation";
import { goSignUp, getDupleEmail } from "../../api";
import LayoutAuth from "./Layout";

function Registration(props) {
  const { intl } = props;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [emailId, setEmailId] = useState();
  const [validEmail, setValidEmail] = useState(false);
  const [dupleEmail, setDupleEmail] = useState(false);
  const [password, setPassword] = useState();
  const [validPassword, setValidPassword] = useState(false);
  const [confirmPass, setConfirmPass] = useState();
  const [validConfirmPass, setValidConfirmPass] = useState(false);
  const [name, setName] = useState();
  const [validName, setValidName] = useState(false);
  const [nationNum, setNationNum] = useState("82");
  const [validNationNum, setValidNationNum] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState();
  const [validPhoneNumber, setValidPhoneNumber] = useState(false);
  const [companyName, setCompanyName] = useState();
  const [validCompanyName, setValidCompanyName] = useState(false);
  const [department, setDepartment] = useState();
  const [validDepartment, setValidDepartment] = useState(false);

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const doSignUp = async () => {
    //ID중복체크 로직 추가
    setDupleEmail(false);
    setValidEmail(false);
    if (emailId !== undefined) {
      if (!validationEmail(emailId.trim())) {
        setValidEmail(true);
        return false;
      } else {
        setValidEmail(false);
      }
    } else {
      setValidEmail(true);
      return false;
    }

    const emailCheck = await getDupleEmail(emailId);
    console.log(emailCheck);
    if (!emailCheck.result) {
      setDupleEmail(true);
      return false;
    } else {
      setDupleEmail(false);
    }
    if (password !== undefined) {
      if (!validationPassword(password.trim())) {
        setValidPassword(true);
        return false;
      } else {
        setValidPassword(false);
      }
    } else {
      setValidPassword(true);
      return false;
    }

    if (confirmPass !== undefined) {
      if (password !== confirmPass) {
        setValidConfirmPass(true);
        return false;
      } else {
        setValidConfirmPass(false);
      }
    } else {
      setValidConfirmPass(true);
      return false;
    }

    if (phoneNumber !== undefined) {
      if (!validationPhoneNumber(phoneNumber.trim())) {
        setValidPhoneNumber(true);
        return false;
      } else {
        setValidPhoneNumber(false);
      }
    } else {
      setValidPhoneNumber(true);
      return false;
    }

    if (name !== undefined) {
      if (!validationName(name.trim())) {
        setValidName(true);
        return false;
      } else {
        setValidName(false);
      }
    } else {
      setValidName(true);
      return false;
    }

    if (companyName === undefined) {
      setValidCompanyName(true);
      return false;
    } else {
      setValidCompanyName(false);
    }

    if (department === undefined) {
      setValidDepartment(true);
      return false;
    } else {
      setValidDepartment(false);
    }

    const body = {
      loginId: emailId,
      pwd: password,
      pwdChk: confirmPass,
      name: name,
      phone: phoneNumber,
      nationNum: nationNum,
      companyName: companyName,
      department: department,
    };

    const res = await goSignUp(body, "botAdmin");
    console.log("resres", res);
    if (res.result) {
      history.push("/auth/pageId19");
    } else {
      toggleShow();
    }
  };

  return (
    <LayoutAuth>
      <div
        className="login-form login-signin my-5"
        style={{ display: "block" }}
      >
        {/* begin: Email */}
        <p>Email ID</p>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Email ID"
            type="email"
            className={`form-control form-control-solid h-auto py-5 px-6`}
            name="email"
            maxLength="30"
            value={emailId}
            onChange={(e) => setEmailId(e.target.value)}
          />
          {validEmail ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                이메일 정보가 잘못 되었습니다.
              </div>
            </div>
          ) : null}
          {dupleEmail ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                동일한 이메일 ID가 존재 합니다.
              </div>
            </div>
          ) : null}
        </div>
        {/* end: Email */}

        {/* begin: Password */}
        <p>비밀번호</p>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="비밀번호(영어+숫자+특수문자8~20자)"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6`}
            name="password"
            maxLength="25"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {validPassword ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                패스워드는 8~16자리 이며 알파벳, 특수문자, 숫자를 포함해야
                합니다.
              </div>
            </div>
          ) : null}
        </div>
        {/* end: Password */}

        {/* begin: Confirm Password */}
        <p>비밀번호 확인</p>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="비밀번호 확인"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6`}
            name="changepassword"
            maxLength="25"
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
          />
          {validConfirmPass ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                비밀번호와 일치 하지 않습니다.
              </div>
            </div>
          ) : null}
        </div>
        {/* end: Confirm Password */}

        {/* begin: Username */}
        <p>이름</p>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="이름"
            type="text"
            className={`form-control form-control-solid h-auto py-5 px-6`}
            name="name"
            maxLength="10"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {validName ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                이름 형식이 올바르지 않습니다.
              </div>
            </div>
          ) : null}
        </div>
        {/* end: Username */}

        {/* begin: Mobile Phone */}
        <p>휴대폰 번호</p>
        <div className="form-group fv-plugins-icon-container">
          <select
            className="form-control form-control-lg form-control-solid mb-2"
            name="phoneSelect"
            onChange={(e) => setNationNum(e.target.value)}
          >
            <option value="82">South Korea +82</option>
            {/* <option value="test1">test1</option>
            <option value="test2">test2</option> */}
          </select>
          <input
            placeholder="휴대폰 번호를 입력해 주세요."
            type="number"
            className={`form-control form-control-solid h-auto py-5 px-6`}
            name="phoneNumber"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          {validPhoneNumber ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                휴대폰 번호 형식이 올바르지 않습니다.
              </div>
            </div>
          ) : null}
        </div>
        {/* end: CompanyName */}

        {/* begin: Company Name */}
        <p>회사명</p>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="회사명을 입력해 주세요."
            type="text"
            className={`form-control form-control-solid h-auto py-5 px-6`}
            name="companyName"
            maxLength="20"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
          {validCompanyName ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                회사명을 입력해 주세요.
              </div>
            </div>
          ) : null}
        </div>
        {/* end: CompanyName */}

        {/* begin: Company Name */}
        <p>부서명</p>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="부서명을 입력해 주세요."
            type="text"
            className={`form-control form-control-solid h-auto py-5 px-6`}
            name="department"
            maxLength="20"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          />
          {validDepartment ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-danger mt-1 font-size-sm">
                부서명을 입력해 주세요.
              </div>
            </div>
          ) : null}
        </div>
        {/* end: CompanyName */}

        <div className="form-group d-flex flex-wrap flex-center">
          <button
            type="submit"
            disabled={
              !emailId ||
              !phoneNumber ||
              !password ||
              !confirmPass ||
              !name ||
              !companyName ||
              !department
            }
            onClick={doSignUp}
            className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
          >
            <span>회원가입</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>

          <Link to="/auth/login">
            <button
              type="button"
              className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
            >
              취소
            </button>
          </Link>
        </div>
        {/* </form> */}
      </div>
    </LayoutAuth>
  );
}

export default injectIntl(connect(null, auth.actions)(Registration));
